export default __webpack_public_path__ + "static/media/734b8f79f46da58199d5504e0a189112.svg";